import { defineMessages } from 'react-intl'

const scope = `procurify.components.TaxSelect`

export default defineMessages({
  selectPlaceholderText: {
    id: `${scope}.selectPlaceholderText`,
    defaultMessage: 'Select tax',
  },
  defaultTaxLabel: {
    id: `${scope}.defaultTaxLabel`,
    defaultMessage: 'Default',
  },
})
